import { intword, intcomma } from 'journalize';
import * as d3 from 'd3';

export function customNumFormat(d, i) {
  if (i == 0) {
    return ``;
  } else if (i == 1) {
    return `${d3.format('~s')(d)}`;
  } else if (i == 2) {
    return `${intcomma(intword(d)).replace(' million', 'M')}`;
  } else if (i == 3) {
    return `${intcomma(intword(d)).replace(' million', 'M')}`;
  }
}

export function customNumFormatMini(d, i) {
  if (i == 0) {
    return ``;
  } else if (i == 1) {
    return `${d3.format('~s')(d)}`;
  } else if (i == 2) {
    return `${intcomma(intword(d)).replace(' million', 'M')}`;
  }
}

export function customBarNumFormat(d) {
  return `${intcomma(intword(d)).replace(' million', 'M')}`;
}